import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { UserNotificationType } from "../../shared-new/enums/notification-type.enum";

export class User {
  emailAddress: string;
  image: string;
  name: string;
  userId: number;
  userLogin: string;
}

export class UserModel {
  userId?: number;
  active?: true;
  firstName?: string;
  lastName?: string;
  username?: string;
  image?: string;
  email: string;
  emailId?: string;
  emailSignature?: string;
  phoneNumber?: string;
  countryCode?: string;
  sendEmailFrom?: string;
  phone?: string;
  message: string;
  userRole?: false;
  isAdmin?: false;
  isPrimaryUser?: false;
  notificationSettings: { [key: number]: boolean };
  static asFormGroup(model: UserModel, notificationTypes: UserNotificationType[]): FormGroup {
    const fg = new FormGroup({
      userName: new FormControl(model?.username, []),
      firstName: new FormControl(model?.firstName, [Validators.required]),
      lastName: new FormControl(model?.lastName, [Validators.required]),
      phoneNumber: new FormControl(model?.phoneNumber, []),
      countryCode: new FormControl(model?.countryCode, []),
      emailId: new FormControl(model?.emailId, [Validators.required, Validators.email]),
      userRole: new FormControl(model?.userRole, []),
      isAdmin: new FormControl(model?.isAdmin, [Validators.required]),
      isPrimaryUser: new FormControl(model?.isPrimaryUser, []),
      phoneNumberControl: new FormControl ({
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      }, [Validators.required]),
      notifications: new FormArray(
        (notificationTypes ?? []).map(nt =>
          new FormGroup({
            notificationTypeId: new FormControl(nt.notificationTypeId),
            isEnable: new FormControl(nt.isEnable),
            name: new FormControl(nt.name)
          })
        )
      )
    });
    return fg;
  }
}

export enum UserTableFields {
  USER_NAME = 'username',
  EMAIL_ID = 'emailId',
  PHONE_NUMBER = 'phoneNumber',
  USER_ROLE = 'userRole',
  FIRST_NAME = 'firstName'
}
